export default __webpack_public_path__ + "static/phBizCard-92fd08101cea579d7eeb767311cbf827.jpeg";